import React from "react";
import "./OurTeam.css";
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";

const teamMembers = [
  {
    name: "Dhruv Jhang",
    image: "https://cdn.gdscsrmrmp.club/team/people/Dhruv-Jhang.png",
    position: "Lead",
    github: "https://github.com/DhruvJhang",
    linkedin: "https://www.linkedin.com/in/dhruv-jhang/",
    twitter: "https://twitter.com/JhangDhruv",
    instagram: "https://www.instagram.com/beingdhruv_2003/",
  },
  {
    name: "Sarvesh M Rao",
    image: "https://cdn.gdscsrmrmp.club/team/people/Sarvesh-M-Rao.png",
    position: "Technical Lead",
    github: "https://go.sarveshmrao.in/gh",
    linkedin: "https://go.sarveshmrao.in/li",
    twitter: "https://go.sarveshmrao.in/twitter",
    instagram: "https://go.sarveshmrao.in/ig",
  },
  {
    name: "Ashwin B",
    image: "https://cdn.gdscsrmrmp.club/team/people/Ashwin-Ahn.png",
    position: "Content Lead",
    github: "https://github.com/ahn1305",
    linkedin: "https://www.linkedin.com/in/ahn1305/",
    twitter: "https://twitter.com/ahn1305",
    instagram: "https://www.instagram.com/ashwin_jahseh/",
  },
  {
    name: "A Jayannth Venkat",
    image: "https://cdn.gdscsrmrmp.club/team/people/Jayannth-Venkat-A.png",
    position: "Management Lead",
    github: "https://github.com/JayannthVenkat",
    linkedin: "https://www.linkedin.com/in/jayannth-venkat-91358b220",
    twitter: "https://twitter.com/",
    // NO TWITTER LINK
    instagram: "https://www.instagram.com/jayannthvenkat/",
  },
  {
    name: "Srishti Singh",
    image: "https://cdn.gdscsrmrmp.club/team/people/Srishti-Singh.png",
    position: "Marketing Lead",
    github: "https://github.com/Srishti1246",
    linkedin: "https://www.linkedin.com/in/srishti-singh-0a6b85248",
    twitter: "https://twitter.com/srishti_twts/",
    instagram: "https://instagram.com/srishti_._singh/",
  },
  {
    name: "Prashanth G",
    image: "https://cdn.gdscsrmrmp.club/team/people/Prashanth.png",
    position: "UI/UX Lead",
    github: "https://github.com/",
    // NO GITHUB LINK
    linkedin: "https://www.linkedin.com/in/prashanth-g-399225202/",
    twitter: "https://twitter.com/Prashan14518598",
    instagram: "https://instagram.com/praashhh._",
  },
  {
    name: "Trusha V",
    image: "https://cdn.gdscsrmrmp.club/team/people/Trusha-V.png",
    position: "Design Lead",
    github: "https://github.com/Trusha2003/",
    linkedin: "https://www.linkedin.com/in/trusha-v-7a56b3255",
    twitter: "https://twitter.com/v_trusha/",
    instagram: "https://instagram.com/the._.pioneer?igshid=NTA5ZTk1NTc=",
  },
  {
    name: "Ashwathaman S",
    image: "https://cdn.gdscsrmrmp.club/team/people/Ashwathaman-S.png",
    position: "Web Dev Lead",
    github: "https://github.com/Ashwaaahere",
    linkedin: "https://www.linkedin.com/in/ashwathaman-s-024235217/",
    twitter: "https://twitter.com/",
    // NO TWITTER LINK,
    instagram: "https://www.instagram.com/_its_ashwaa/",
  },
  // Add more team members as needed
];

const Mentors = [
  {
    name: "Aryan Khandelwal",
    image: "https://cdn.gdscsrmrmp.club/team/people/Aryan-Khandelwal.png",
    position: "Mentor",
    github: "https://github.com/0127aryan",
    linkedin: "https://www.linkedin.com/in/aryan-khandelwal-796a2521b/",
    twitter: "https://mobile.twitter.com/AryanKh53383160",
    instagram: "https://www.instagram.com/0127_aryan/",
  },
  {
    name: "Rishika Rakta",
    image: "https://cdn.gdscsrmrmp.club/team/people/Rishika-Rakta.png",
    position: "Mentor",
    github: "https://github.com/rrishika222",
    linkedin: "https://www.linkedin.com/in/rishika-rakta",
    twitter: "https://twitter.com/r_rishikaaa/",
    instagram: "https://instagram.com/r.rishikaaa/",
  },
];

const TechnicalTeam = [
  // {
  //   name: "Sarvesh M Rao",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Sarvesh-M-Rao.png",
  //   github: "https://go.sarveshmrao.in/gh",
  //   linkedin: "https://go.sarveshmrao.in/li",
  //   twitter: "https://go.sarveshmrao.in/twitter",
  //   instagram: "https://go.sarveshmrao.in/ig",
  //   // position: 'Technical Team Member'
  // },
  // {
  //   name: "Ashwin B",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Ashwin-Ahn.png",
  //   github: "https://github.com/sriharis",
  //   linkedin: "https://www.linkedin.com/in/sriharis/",
  //   twitter: "https://twitter.com/sriharis_",
  //   instagram: "https://www.instagram.com/sriharis_/",
  //   //position: 'Technical Team Member'
  // },
  // {
  //   name: "Ashwathaman S",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Ashwathaman-S.png",
  //   github: "https://github.com/Ashwaaahere",
  //   linkedin: "https://www.linkedin.com/in/ashwathaman-s-024235217/",
  //   twitter: "https://twitter.com/",
  //   // NO TWITTER LINK
  //   instagram: "https://www.instagram.com/_its_ashwaa/",
  //   //position: 'Technical Team Member'
  // },
  // {
  //   name: "Kailash Mathur",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Kailash-Mathur.png",
  //   github: "https://github.com/kail02",
  //   linkedin: "http://www.linkedin.com/in/ahn1305",
  //   twitter: "http://www.linkedin.com/in/ahn1305",
  //   instagram: "https://instagram.com/kailash_._?igshid=YmMyMTA2M2Y=",
  //   //position: 'Technical Team Member'
  // },
  // {
  //   name: "Tanuj Ravi Rao",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Tanuj-Ravi-Rao.png",
  //   github: "https://github.com/IAmSalvaMartini",
  //   linkedin: "https://www.linkedin.com/in/iamsalvamartini/",
  //   twitter: "https://twitter.com/IAmSalvaMartini",
  //   instagram: "https://www.instagram.com/madgenius_gamer/",
  //   //position: 'Technical Team Member'
  // },
  // {
  //   name: "Disshad KP",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Disshad-KP.png",
  //   github: "https://github.com/Arstos",
  //   linkedin: "http://www.linkedin.com/in/disshad-kp-80b421202/",
  //   twitter: "https://twitter.com/Disshad2903?s=08",
  //   instagram: "https://www.instagram.com/sriharis_/",
  //   //position: 'Technical Team Member'
  // },
  {
    name: "S Gaurau Siddharth",
    image: "https://cdn.gdscsrmrmp.club/team/people/Gaurau-Siddarth.png",
    github: "https://github.com/CoderSidd2k",
    linkedin: "https://www.linkedin.com/in/gaurau-siddarth-s/",
    twitter: "https://twitter.com/GaurauSiddarth",
    instagram: "https://www.instagram.com/_dat_sidd/",
    //position: 'Technical Team Member'
  },
  {
    name: "K Harshita",
    image: "https://cdn.gdscsrmrmp.club/team/people/Harshita-Ketha.png",
    github: "https://github.com/K-Harshita",
    linkedin: "https://www.linkedin.com/in/harshita-ketha-a30a7022b/",
    twitter: "https://twitter.com/",
    // NO TWITTER LINK
    instagram: "https://www.instagram.com/holding_heosphoros/?next=%2F",
    //position: 'Technical Team Member'
  },
  {
    name: "Mohamed Arafath",
    image: "https://cdn.gdscsrmrmp.club/team/people/Mohamed-Arafath.png",
    github: "https://github.com/MohamedArafath205",
    linkedin: "https://www.linkedin.com/in/mohdarafath",
    twitter: "https://twitter.com/",
    // NO TWITTER LINK
    instagram: "https://www.instagram.com/mohamedarafath205/",
    //position: 'Technical Team Member'
  },
];

const contentTeamMembers = [
  // {
  //   name: "K Harshita",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Harshita-Ketha.png",
  //   github: "https://github.com/K-Harshita",
  //   linkedin: "https://www.linkedin.com/in/harshita-ketha-a30a7022b/",
  //   twitter: "https://twitter.com/sriharis_",
  //   instagram: "https://www.instagram.com/holding_heosphoros/?next=%2F",
  //   //position: 'Technical Team Member'
  // },
  // {
  //   name: "Srishti Singh",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Srishti-Singh.png",
  //   github: "https://github.com/Srishti1246",
  //   linkedin: "https://www.linkedin.com/in/srishti-singh-0a6b85248",
  //   twitter: "https://twitter.com/srishti_twts?t=W89IF6dIeh5w6TDc9MNnUA&s=08",
  //   instagram: "https://instagram.com/srishti_._singh?igshid=ZDdkNTZiNTM=",
  //   //position: 'Technical Team Member'
  // },
  // {
  //   name: "Mohamed Arafath",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Mohamed-Arafath.png",
  //   github: "https://github.com/MohamedArafath205",
  //   linkedin: "https://www.linkedin.com/in/mohdarafath",
  //   twitter: "https://twitter.com/sriharis_",
  //   instagram: "https://www.instagram.com/mohamedarafath205/",
  //   //position: 'Technical Team Member'
  // },
  {
    name: "K Meghana Achary",
    image: "https://cdn.gdscsrmrmp.club/team/people/Meghana-Achary.png",
    github: "https://github.com/Meghana-204",
    linkedin: "https://www.linkedin.com/in/meghana-achary-91a7b4227",
    twitter: "https://twitter.com/",
    // NO TWITTER LINK
    instagram: "https://instagram.com/cocobean_594/",
    //position: 'Technical Team Member'
  },
  // {
  //   name: "Prashanth G",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Prashanth.png",
  //   github: "https://github.com/",
  //   // NO GITHUB LINK
  //   linkedin: "https://www.linkedin.com/in/prashanth-g-399225202/",
  //   twitter: "https://twitter.com/Prashan14518598",
  //   instagram: "https://instagram.com/praashhh._",
  //   //position: 'Technical Team Member'
  // },
  {
    name: "Samiksha Shreya",
    image: "https://cdn.gdscsrmrmp.club/team/people/Samiksha-Shreya.png",
    github: "https://github.com/Samikshashreya",
    linkedin: "https://www.linkedin.com/in/samiksha-shreya-858051220",
    twitter: "https://twitter.com/samiksha_shreya/",
    instagram: "https://www.instagram.com/samikshashreya_/",
    //position: 'Technical Team Member'
  },
  // Add more content team members as needed
];

const designTeamMembers = [
  // {
  //   name: "Trusha V",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Trusha-V.png",
  //   github: "https://github.com/Trusha2003/",
  //   linkedin: "https://www.linkedin.com/in/trusha-v-7a56b3255",
  //   twitter: "https://twitter.com/v_trusha?t=HCbq8XCOCxormS4OWGSNpg&s=09",
  //   instagram: "https://instagram.com/the._.pioneer?igshid=NTA5ZTk1NTc=",
  //   //position: 'Technical Team Member'
  // },
  {
    name: "S Madhuvanthi",
    image: "https://cdn.gdscsrmrmp.club/team/people/Madhuvanthi.png",
    github: "https://github.com/MadhuvanthiShankar",
    linkedin: "https://www.linkedin.com/in/madhuvanthi-shankar-6675a0220",
    twitter: "https://twitter.com/Madhuvanthi_111/",
    instagram: "https://www.instagram.com/madhuvanthi_111/",
  },
  {
    // NONE OF THE LINKS HAVE BEEN UPDATED
    name: "Krishn Patel",
    image: "https://cdn.gdscsrmrmp.club/team/people/Krishn-Patel.png",
    github: "https://github.com/",
    linkedin: "https://www.linkedin.com/in/krishn-patel-a7310822b/",
    twitter: "https://twitter.com/Krishn1610",
    instagram: "https://www.instagram.com/krishnpatel1610/",
    //position: 'Technical Team Member'
  },
  {
    name: "Pranav S",
    image: "https://cdn.gdscsrmrmp.club/team/people/Pranav-S.png",
    github: "https://github.com/pranav290804",
    linkedin: "www.linkedin.com/in/pranav-suresh-140b3124b",
    twitter: "https://twitter.com/pranav290804",
    instagram: "https://www.instagram.com/pranav._.suresh/",
    //position: 'Technical Team Member'
  },
  {
    name: "Eeshwar S",
    image: "https://cdn.gdscsrmrmp.club/team/people/Eeshwar-S.png",
    github: "https://github.com/darkboi3301",
    linkedin: "https://www.linkedin.com/in/eeshwar-sivasankar-889984187/",
    twitter: "https://twitter.com/Eeshwarsivasan3",
    instagram: "https://www.instagram.com/darkboi3301/",
    //position: 'Technical Team Member'
  },

  // {
  //   name: "Nikhil. P",
  //   image: "https://cdn.gdscsrmrmp.club/team/people/Nikhil-P.png",
  //   github: "https://github.com/NikhilReddyPuli",
  //   linkedin: "http://www.linkedin.com/in/thenikhilreddy",
  //   twitter: "https://twitter.com/",
  //   // NO TWITTER LINK
  //   instagram: "https://www.instagram.com/tenacious_nikh/?hl=en",
  //   //position: 'Technical Team Member'
  // },
  // Add more design team members as needed
];

const OurTeam = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      <h1>Core Team</h1>
      <div className="team-members">
        {teamMembers.map((member) => (
          <div key={member.name} className="member-card">
            <div className="member-image">
              <img
                src={member.image}
                alt={member.name}
                style={{ borderRadius: "50%" }}
              />
            </div>
            <div className="member-info">
              <div className="member-details">
                <h4>{member.name}</h4>
                <h4>{member.position}</h4>
              </div>
              <div className="social-links">
                <a href={member.github} target="_blank" rel="noreferrer">
                  <FaGithub />
                </a>
                <a href={member.linkedin} target="_blank" rel="noreferrer">
                  <FaLinkedin />
                </a>
                <a href={member.twitter} target="_blank" rel="noreferrer">
                  <FaTwitter />
                </a>
                <a href={member.instagram} target="_blank" rel="noreferrer">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h1>Mentors</h1>
      <div className="team-members">
        {Mentors.map((member) => (
          <div key={member.name} className="member-card">
            <div className="member-image">
              <img
                src={member.image}
                alt={member.name}
                style={{ borderRadius: "50%" }}
              />
            </div>
            <div className="member-info">
              <div className="member-details">
                <h4>{member.name}</h4>
                <h4>{member.position}</h4>
              </div>
              <div className="social-links">
                <a href={member.github} target="_blank" rel="noreferrer">
                  <FaGithub />
                </a>
                <a href={member.linkedin} target="_blank" rel="noreferrer">
                  <FaLinkedin />
                </a>
                <a href={member.twitter} target="_blank" rel="noreferrer">
                  <FaTwitter />
                </a>
                <a href={member.instagram} target="_blank" rel="noreferrer">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h1>Technical Team</h1>
      <div className="team-members">
        {TechnicalTeam.map((member) => (
          <div key={member.name} className="member-card">
            <div className="member-image">
              <img
                src={member.image}
                alt={member.name}
                style={{ borderRadius: "50%" }}
              />
            </div>
            <div className="member-info">
              <div className="member-details">
                <h4>{member.name}</h4>
                <h4>{member.position}</h4>
              </div>
              <div className="social-links">
                <a href={member.github} target="_blank" rel="noreferrer">
                  <FaGithub />
                </a>
                <a href={member.linkedin} target="_blank" rel="noreferrer">
                  <FaLinkedin />
                </a>
                <a href={member.twitter} target="_blank" rel="noreferrer">
                  <FaTwitter />
                </a>
                <a href={member.instagram} target="_blank" rel="noreferrer">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h1>Content Team</h1>
      <div className="team-members">
        {contentTeamMembers.map((member) => (
          <div key={member.name} className="member-card">
            <div className="member-image">
              <img
                src={member.image}
                alt={member.name}
                style={{ borderRadius: "50%" }}
              />
            </div>
            <div className="member-info">
              <div className="member-details">
                <h4>{member.name}</h4>
                <h4>{member.position}</h4>
              </div>
              <div className="social-links">
                <a href={member.github} target="_blank" rel="noreferrer">
                  <FaGithub />
                </a>
                <a href={member.linkedin} target="_blank" rel="noreferrer">
                  <FaLinkedin />
                </a>
                <a href={member.twitter} target="_blank" rel="noreferrer">
                  <FaTwitter />
                </a>
                <a href={member.instagram} target="_blank" rel="noreferrer">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <h1>Design Team</h1>
      <div className="team-members">
        {designTeamMembers.map((member) => (
          <div key={member.name} className="member-card">
            <div className="member-image">
              <img
                src={member.image}
                alt={member.name}
                style={{ borderRadius: "50%" }}
              />
            </div>
            <div className="member-info">
              <div className="member-details">
                <h4>{member.name}</h4>
                <h4>{member.position}</h4>
              </div>
              <div className="social-links">
                <a href={member.github} target="_blank" rel="noreferrer">
                  <FaGithub />
                </a>
                <a href={member.linkedin} target="_blank" rel="noreferrer">
                  <FaLinkedin />
                </a>
                <a href={member.twitter} target="_blank" rel="noreferrer">
                  <FaTwitter />
                </a>
                <a href={member.instagram} target="_blank" rel="noreferrer">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurTeam;
